export const ResponsiveJoinEfb = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="130"
      height="127"
      viewBox="0 0 130 127"
      fill="none"
      className="absolute bottom-0 end-0 flex md:hidden"
    >
      <g opacity="0.3" clipPath="url(#clip0_8196_97956)">
        <path
          d="M99.573 87.3327L89.551 89.6414L102.627 147.438L112.649 145.129L99.573 87.3327Z"
          fill="#CCC2BF"
        />
        <path
          d="M97.5649 63.7126L93.1053 73.0586L146.04 98.7766L150.5 89.4306L97.5649 63.7126Z"
          fill="#CCC2BF"
        />
        <path
          d="M130.954 24.8633L78.019 50.5813L82.4786 59.9273L135.414 34.2093L130.954 24.8633Z"
          fill="#CCC2BF"
        />
        <path
          d="M18.6991 27.1469L10.6618 33.6141L47.2916 79.9645L55.3289 73.4973L18.6991 27.1469Z"
          fill="#CCC2BF"
        />
        <path d="M59.2515 89.9861H0.5V100.359H59.2515V89.9861Z" fill="#CCC2BF" />
        <path
          d="M74.4826 97.1826L37.8528 143.533L45.8901 150L82.5199 103.65L74.4826 97.1826Z"
          fill="#CCC2BF"
        />
        <path
          d="M68.7237 0L55.6475 57.7962L65.6695 60.1049L78.7458 2.30869L68.7237 0Z"
          fill="#D5F477"
        />
      </g>
      <defs>
        <clipPath id="clip0_8196_97956">
          <rect width="150" height="150" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
